import { t } from "i18next";
import { Trash2 } from "lucide-react";

import type { ColumnsClarFactory } from "@/core/components/shared/data-table";
import { RowActionsMenu } from "@/core/components/shared/data-table";
import { NoTranslate } from "@/core/components/ui/no-translate";
import { formatDateWithFallback } from "@/core/utils/func/formatDateWithFallback";
import type { MerchantFeeOverrideDto } from "@/features/merchant/api/dto";

export type FeeOverrideRow = MerchantFeeOverrideDto & { id: string };

/**
 * Colonnes des dérogations tarifaires d'un marchand (avec action de
 * suppression pilotée par la section parent).
 */
export const feeOverridesColumnsFactory = (
  onDelete: (row: FeeOverrideRow) => void
): ColumnsClarFactory<FeeOverrideRow> =>
  () => [
    {
      id: "productCode",
      accessorKey: "productCode",
      header: t("merchant.feeOverrides.columns.productCode"),
      cell: ({ getValue }) => (
        <NoTranslate as="span" className="font-medium">
          {(getValue() as string) || "—"}
        </NoTranslate>
      ),
      meta: { type: "text" },
    },
    {
      id: "feeRuleId",
      accessorKey: "feeRuleId",
      header: t("merchant.feeOverrides.columns.feeRuleId"),
      cell: ({ getValue }) => (
        <NoTranslate as="span" className="font-mono text-xs">
          {(getValue() as string) || "—"}
        </NoTranslate>
      ),
      meta: { type: "text" },
    },
    {
      id: "createdAt",
      accessorKey: "createdAt",
      header: t("merchant.feeOverrides.columns.createdAt"),
      cell: ({ getValue }) => (
        <NoTranslate as="span">
          {formatDateWithFallback((getValue() as string) ?? "", "—")}
        </NoTranslate>
      ),
      meta: { type: "text" },
    },
    {
      id: "actions",
      header: t("common.actions"),
      enableHiding: false,
      cell: ({ row }) => (
        <RowActionsMenu
          actions={[
            {
              id: "delete",
              label: t("merchant.feeOverrides.actions.delete"),
              icon: Trash2,
              variant: "destructive",
              onClick: () => onDelete(row.original),
            },
          ]}
        />
      ),
      meta: { type: "denied" },
    },
  ];
